import styled from 'styled-components';

import { Button } from '@calm-web/design-system';

export const VideoContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 400px;
	height: 250px;
	margin: 0 auto 16px auto;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	flex-shrink: 0;
`;

export const Video = styled.video`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
`;

export const PreviewOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PreviewImage = styled.img`
	max-width: 100%;
	max-height: 100%;
	border-radius: 8px;
`;

export const StatusText = styled.div`
	text-align: center;
	margin-bottom: 16px;
	padding: 8px;
	border-radius: 8px;
	background: rgba(255, 255, 255, 0.05);
	color: #333;
	font-weight: 500;
	font-size: 14px;
	flex-shrink: 0;
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	flex-wrap: wrap;
	flex-shrink: 0;
`;

export const StyledCard = styled.div`
	min-width: 700px;
	width: 700px;
	height: 400px;
	max-height: 400px;
	padding: 40px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	background: #fff;
	flex-shrink: 0;
	scroll-snap-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	overflow: hidden;

	/* Entrance animation */
	animation: slideInFromRight 0.6s cubic-bezier(0.4, 0, 0.2, 1);

	@keyframes slideInFromRight {
		from {
			opacity: 0;
			transform: translateX(50px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}
`;

export const StyledButton = styled(Button).attrs({
	backgroundColor: 'accessibleBrandGradient' as const,
})`
	min-width: 160px;
`;

export const CaptureTitle = styled.div`
	margin-bottom: 12px;
`;

export const CaptureDescription = styled.div`
	margin-bottom: 20px;
	color: #6b7280;
`;
